import React, {useEffect, useRef, useState} from 'react'

import './CommentPicker.scss'
import FacebookLogin from 'react-facebook-login';
import PagesSelectionItem from "../../UI/PagesSelectionItem";
import moment from "moment";
import cl from "../../UI/FacebookLoginButton/FacebookLoginButton.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebook} from "@fortawesome/free-brands-svg-icons";

const CommentPicker = (props) => {
    const btnRef = useRef()
    const [btnProgress, setBtnProgress] = useState(0)
    let fillStep = 0
    const limit = 200;
    const [login, setLogin] = useState(false)
    const [pages, setPages] = useState([])
    const [page, setPage] = useState({})
    const [posts, setPosts] = useState([])
    const [post, setPost] = useState({})
    const [comments, setComments] = useState([])
    const numbers = Array.from({ length: 5 }, (_, i) => i + 1);
    const [number, setNumber] = useState(1)
    const [winners, setWinners] = useState([])

    useEffect(() => {
        if (typeof FB === 'undefined') {

        }else{
            FB.getLoginStatus(function(response) {   // See the onlogin handler
                statusChangeCallback(response);
            });
        }
    },[]);

    const statusChangeCallback = (response) => {
        console.log('statusChangeCallback');
        console.log(response);
        if (response.status === "connected") {
            setLogin(true)
            testAPI();
        } else {
            setLogin(false)
        }
    }

    const logout = () =>{
        FB.api('/me/permissions', 'delete', function(response) {
            setLogin(false)
            setPages([])
            setPage({})
            setPost({})
            setPosts([])
            setNumber(1)
            setComments([])
            setBtnProgress(0)
            setWinners([])
        });
    }
    const testAPI = () => {                      // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
        FB.api('/me/accounts', function(response) {
            setPages(response.data)
            console.log(response);
        });
    }

    const responseFacebook = (response) => {
        FB.getLoginStatus(function(response) {   // See the onlogin handler
            statusChangeCallback(response);
        });
    }

    const handlePage = (page) => {
        setPage(page)
        setPost({})
        setComments([])
        setBtnProgress(0)
        setWinners([])
        FB.api(`/${page.id}/feed`, 'get', {access_token: page.access_token}, function(response) {
            console.log('response', response)
            setPosts(response.data)
        });
    }

    const handlePost = (post) => {
        setBtnProgress(0)
        setPost(post)
        setWinners([])
        getComments(post.id)
    }

    const fillBtn = (total = 100, cCount) => {
        const step = Math.floor((100 * cCount)/total)
        return step
    }

    const getComments = (postId, after = "") => {

        FB.api(`/${postId}/comments`, 'get', {access_token: page.access_token, after: after, limit: limit, summary: "1", fields: 'id,message,created_time,from{name,picture{url}}'}, function(response) {
            const step = fillBtn(response.summary?.total_count, response.data.length || 0)
            setBtnProgress((cur)=> cur + step + 1)
            setComments((curComments)=>([...curComments, ...response.data]))
            if(response.paging.next){
                getComments(postId, response.paging.cursors.after)
            }
        })
    }

    const handleNumber = (e) => {
        e.preventDefault()
        setNumber(e.currentTarget.value)
    }

    const getWinners = (e) => {
        const winCount = Array.from({ length: number }, (_, i) => i + 1);
        const selectedComents = []

        winCount.map((i) => {
            let curComments = comments.filter((comment) => !selectedComents.map(w => w.id).includes(comment.id))
            const winner = curComments[(Math.floor(Math.random() * curComments.length))]
            selectedComents.push(winner)
        })

        setWinners(selectedComents)
    }

    return (
        <>

            <div className="row">
                <div className="col-lg-10">

                    <h3 className="fw-bold my-4">
                        Facebook comment picker
                    </h3>

                    <div className="connect-page-msg message my-3">
                        This free Facebook comment picker will help you choose a random winner for your promotion,
                        sweepstake, giveaway or contest.
                    </div>

                    <div className="connect-page-msg message mt-3 mb-4">
                        To get started, connect your Facebook account and select the pages you'd like to use.
                    </div>

                    {login ?
                        <button id="logout" onClick={logout} className="fbBtn">
                            <FontAwesomeIcon icon={faFacebook} color="white"/>
                            <span>Logout</span>
                        </button> :
                        <FacebookLogin
                            appId="3328663607280474"
                            version="19.0"
                            autoLoad={false}
                            scope="public_profile,email,pages_show_list,business_management,pages_read_user_content"
                            icon="fa-facebook"
                            size="medium"
                            cssClass="fbBtn"
                            icon={<FontAwesomeIcon icon={faFacebook} color="white"/>}
                            callback={responseFacebook}/>}


                    <div className="col-lg-4 ">

                        <h4 className="fw-bold my-4">
                            Settings
                        </h4>

                        <div className="my-2">
                            Pages
                        </div>

                        <div className="accounts-list position-relative">
                            <button type="button" className="form-select dropdown-toggle actions-btn" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                <span className="ms-2">{page.name || "Select your Facebook Page"}</span>
                            </button>
                            <ul className="dropdown-menu w-100 pages-selector">
                                {pages && pages.length > 0 ?
                                    (pages.map((page, index) => {
                                        return <div key={page.id}>
                                            <PagesSelectionItem
                                                noIcon={true}
                                                pageId={page.id}
                                                pageName={page.name}
                                                pageType={page.access_token}
                                                handleInputChange={() => handlePage(page)}/>
                                        </div>
                                    }))
                                    : <li>
                                        <button className="dropdown-item">
                                            <span className="ms-2">Select your Facebook Page</span>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>

                        <div className="my-2">
                            Posts
                        </div>

                        <div className="accounts-list position-relative">
                            <button type="button" className="form-select dropdown-toggle actions-btn" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                {post.id ? <span className="ms-2">
                                                <span className="created-time">[{moment(post.created_time).format('MMMM Do YYYY, hh:mm:ss')}]</span>
                                        {post.message?.substring(0,50)}
                                        </span> :
                                    <span className="ms-2">Select your Facebook Post</span>}
                            </button>
                            <ul className="dropdown-menu w-100 pages-selector">
                                {posts && posts.length > 0 ?
                                    (posts.map((post, index) => {
                                        return <div key={post.id}>
                                            <PagesSelectionItem
                                                noIcon={true}
                                                pageId={post.id}
                                                pageName={post.message?.substring(0,50)}
                                                date={moment(post.created_time).format('MMMM Do YYYY, hh:mm:ss')}
                                                handleInputChange={() => handlePost(post)}/>
                                        </div>
                                    }))
                                    : <li>
                                        <button className="dropdown-item">
                                            <span className="ms-2">Select your Facebook Post</span>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>

                        <div className="my-2">
                            Number of winners
                        </div>

                        <div className="accounts-list position-relative">
                            <button type="button" className="form-select dropdown-toggle actions-btn" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                <span className="ms-2">{number}</span>
                            </button>
                            <ul className="dropdown-menu w-100 pages-selector">
                                {(numbers.map((number) => {
                                    return <div key={number}>
                                        <PagesSelectionItem
                                            noIcon={true}
                                            pageId={number}
                                            pageName={number}
                                            handleInputChange={handleNumber}/></div>

                                }))
                                }
                            </ul>
                        </div>

                        <div className="my-4">
                            <button type="submit"
                                    style={{background: btnProgress > 0 && `linear-gradient(to right, #2bae76 ${btnProgress}%,#2bae76 ${btnProgress}%,#75caa6 25%,#75caa6 100%)`}}
                                    className="btn btn-primary"
                                    onClick={getWinners}
                                    ref={btnRef }
                                    disabled={comments.length > 0 ? false : true}>Start</button>
                        </div>
                        { winners && winners.length > 0 &&
                        <div className="winners-section">
                            {(winners.map((winner) => {
                                return <div key={winner.id} className="winner">
                                    <div className="image">
                                        <img src={winner.from?.picture?.data?.url}/>
                                    </div>
                                    <div className="comment">
                                        <div className="author">
                                            {winner.from?.name}
                                        </div>
                                        <div className="message">
                                            {winner.message}
                                        </div>
                                    </div>
                                </div>
                            }))}
                        </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default React.memo(CommentPicker)